import { merge } from 'lodash';
import React from 'react';
import { allIcons as defaultIconsMap } from '../icons';
import { jsx as _jsx } from "react/jsx-runtime";
export var IconsProvider = _ref => {
  var {
    children,
    icons = {}
  } = _ref;
  return /*#__PURE__*/_jsx(IconsContext.Provider, {
    value: merge(defaultIconsMap, icons),
    children: children
  });
};
export var IconsContext = /*#__PURE__*/React.createContext({});
//# sourceMappingURL=IconsProvider.js.map